export default __webpack_public_path__ + "images/fda8008bf8be8200d01885297c1eab09-seasonal_module_spd_parties_mobile.webp";